import Router from './Router';
import GlobalStyle from '../src/Components/Helpers/GlobalStyle';
import { ThemeProvider } from 'styled-components';
import useTheme from '../src/Components/Helpers/useTheme';

const App = (props) => {
  const theme = useTheme();

  return (
    <div className={props.className}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Router />
      </ThemeProvider>
    </div>
  );
};

export default App;
